export const productsSchema = {
	schema: {
		title: 'products schema',
		description: 'Products Schema',
		version: 0,
		primaryKey: 'id',
		type: 'object',
		properties: {
			id: {
				type: 'string',
				maxLength: 250,
			},
			name: {
				type: 'string',
			},
			prdgroup3_c: {
				type: 'string',
			},
			productgroup3description_c: {
				type: 'string',
			},
			materialcode_c: {
				type: 'string',
			},
		},
		required: ['id', 'name', 'prdgroup3_c', 'productgroup3description_c', 'materialcode_c'],
	},
};
